// App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import Sidebar from "./components/Sidebar";
import Dashboard from "./components/Dashboard";

// Orders
import Orders from "./components/pages/orders/Orders.jsx";
import OrderSummary from "./components/pages/orders/OrderSummary.jsx";
import PendingOrders from "./components/pages/orders/PendingOrders.jsx";
import OrderDetails from "./components/pages/orders/OrderDetails.jsx";
import ConfirmedOrders from "./components/pages/orders/ConfirmedOrders.jsx";
import ShippedOrders from "./components/pages/orders/ShippedOrders.jsx";
import DeliveredOrders from "./components/pages/orders/DeliveredOrders.jsx";
import CanceledOrders from "./components/pages/orders/CancelledOrders.jsx";

// Category
import CategoryManagement from "./components/pages/Category";
import SubcategoryManagement from "./components/pages/subcategories";

// Users
import AllUsers from "./components/pages/Users/allUsers";
import CreateUser from "./components/pages/Users/createUser";
import NewUsers from "./components/pages/Users/newUsers";
import UserDetails from "./components/pages/Users/UserDetails.jsx";
import InterestedBuyer from "./components/pages/Users/interestedBuyer.jsx";

// Admins
import CreateAdmin from "./components/admin/createAdmin";
import ManageAdmins from "./components/admin/getAllAdmins";

// Interested users
import InterestedUsers from "./components/pages/interestedUsers/interestedUsers";

// ✅ manageProducts (MATCHING YOUR FOLDER EXACTLY)
import Products from "./components/pages/manageProducts/products.jsx";
import NewProduct from "./components/pages/manageProducts/NewProduct.jsx";
import TotalProducts from "./components/pages/manageProducts/TotalProducts.jsx";
import ApprovedProducts from "./components/pages/manageProducts/ApprovedProducts.jsx";
import NotApprovedProducts from "./components/pages/manageProducts/NotApprovedProducts.jsx";
import ProductDetails from "./components/pages/manageProducts/ProductDetails.jsx";
import CreateProduct from "./components/pages/manageProducts/CreateProduct.jsx";
import SellerProduct from "./components/pages/manageProducts/SellerProducts.jsx";
import SaleBySellerPage from "./components/pages/manageProducts/SaleBySellerPage.jsx";
import SaleByOGCSPage from "./components/pages/manageProducts/SaleByOGCSPage.jsx";
import SellerDetailsPage from "./components/pages/manageProducts/SellerDetailsPage.jsx";
import OgcsSellerDetailsPage from "./components/pages/manageProducts/OgcsSellerDetailsPage.jsx";

// Sellers
import AllSellers from "./components/pages/Sellers/allSellers.jsx";
import SellersPage from "./components/data/seller.jsx";

// Accounts
import SellerProductsPage from "./components/account/sellerPayment.jsx";
import SellerRegistrationPaymentsPage from "./components/account/SellerRegistrationPaymentPage.jsx";

// Data Pages
import AllUsersPage from "./components/data/user.jsx";
import AdminDataPage from "./components/data/admin.jsx";
import AddressDataPage from "./components/data/address.jsx";
import CartDataPage from "./components/data/carts.jsx";
import CategoryDataPage from "./components/data/categories.jsx";
import DeliveryChargeDataPage from "./components/data/deliverycharges.jsx";
import SubCategoriesDataPage from "./components/data/subcategories.jsx";
import InterestedUsersDataPage from "./components/data/interestedusers.jsx";
import OtherPaymentDataPage from "./components/data/Otherpayments.jsx";
import OrdersPage from "./components/data/order.jsx";
import OrderTrackingPage from "./components/data/ordertracking.jsx";
import SellerProductVisibilityPage from "./components/data/sellerProductPayments.jsx";
import WishlistPage from "./components/data/wishlist.jsx";
import BulkOrdersPage from "../src/components/pages/BulkOrders.jsx";

// Settings / POS / Locations
import Settings from "./components/pages/Settings.jsx";
import Locations from "./components/pages/Locations.jsx";
import POS from "./components/pages/POS.jsx";

// Auth
import Login from "./components/admin/loginpage";
import Register from "./components/admin/Register.jsx";
import ProtectedRoute from "./components/protectedRoute/protectedRoute.jsx";




// ✅ Layout for protected area
const AdminLayout = () => (
  <div className="flex min-h-screen">
    <Sidebar />
    <div className="flex-grow p-4 bg-gray-100">
      <Outlet />
    </div>
  </div>
);



const App = () => {

  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected (admin) */}
        <Route element={<ProtectedRoute role="admin" />}>
          <Route element={<AdminLayout />}>
            <Route path="/" element={<Dashboard />} />

            {/* Orders */}
            <Route path="/orders" element={<OrderSummary />} />
            <Route path="/orders/all" element={<Orders />} />
            <Route path="/orders/pending" element={<PendingOrders />} />
            <Route path="/orders/confirmed" element={<ConfirmedOrders />} />
            <Route path="/orders/cancelled" element={<CanceledOrders />} />
            <Route path="/orders/delivered" element={<DeliveredOrders />} />
            <Route path="/orders/shipped" element={<ShippedOrders />} />
            <Route path="/orders/:orderId" element={<OrderDetails />} />

            {/* Category */}
            <Route path="/category" element={<CategoryManagement />} />
            <Route path="/subcategories" element={<SubcategoryManagement />} />

            {/* Users */}
            <Route path="/users/all" element={<AllUsers />} />
            <Route path="/users/create" element={<CreateUser />} />
            <Route path="/users/new" element={<NewUsers />} />
            <Route path="/users/interested" element={<InterestedBuyer />} />
            <Route path="/user/:id" element={<UserDetails />} />

            {/* Admins */}
            <Route path="/admins/create" element={<CreateAdmin />} />
            <Route path="/admins/all" element={<ManageAdmins />} />

            {/* Interested Users */}
            <Route path="/salebysellers" element={<InterestedUsers />} />

            {/* Products */}
            <Route path="/products" element={<Products />} />
            <Route path="/products/new" element={<NewProduct />} />
            <Route path="/products/total" element={<TotalProducts />} />
            <Route path="/products/approved" element={<ApprovedProducts />} />
            <Route path="/products/not-approved" element={<NotApprovedProducts />} />
            {/* ✅ FIX: you don't have ApproveProductsPage file, so use NotApprovedProducts */}
            <Route path="/waiting-for-approval" element={<NotApprovedProducts />} />
            <Route path="/products/details/:id" element={<ProductDetails />} />
            <Route path="/products/create" element={<CreateProduct />} />

            {/* Seller Products / Sales */}
            <Route path="/seller-products" element={<SellerProduct />} />
            <Route path="/sale-by-seller" element={<SaleBySellerPage />} />
            <Route path="/seller-details/:sellerId" element={<SellerDetailsPage />} />
            <Route path="/sale-by-ogcs" element={<SaleByOGCSPage />} />
            <Route
              path="/ogcs-product-details/:id"
              element={<OgcsSellerDetailsPage />}
            />

            {/* (Optional) Keep this only if you really use it somewhere */}
            <Route path="/product/:id" element={<ProductDetails />} />

            {/* Sellers */}
            <Route path="/sellers" element={<SellersPage />} />
            <Route path="/sellers/all" element={<AllSellers />} />

            {/* Accounts */}
            <Route path="/accounts/seller" element={<SellerProductsPage />} />
            <Route
              path="/accounts/seller/registration"
              element={<SellerRegistrationPaymentsPage />}
            />

            {/* Data Pages */}
            <Route path="/all-users" element={<AllUsersPage />} />
            <Route path="/admin" element={<AdminDataPage />} />
            <Route path="/address" element={<AddressDataPage />} />
            <Route path="/carts" element={<CartDataPage />} />
            <Route path="/categories" element={<CategoryDataPage />} />
            <Route path="/delivery-charges" element={<DeliveryChargeDataPage />} />
            <Route path="/sub-categories" element={<SubCategoriesDataPage />} />
            <Route path="/interested-users" element={<InterestedUsersDataPage />} />
            <Route path="/other-payments" element={<OtherPaymentDataPage />} />
            <Route path="/order" element={<OrdersPage />} />
            <Route path="/order-tracking" element={<OrderTrackingPage />} />
            <Route
              path="/seller-product-payments"
              element={<SellerProductVisibilityPage />}
            />
            <Route path="/wishlist" element={<WishlistPage />} />

            {/* Settings / POS / Locations */}
            <Route path="/settings" element={<Settings />} />
            <Route path="/pos" element={<POS />} />
            <Route path="/locations" element={<Locations />} />

            <Route path="/bulk-orders" element={<BulkOrdersPage />} />

            {/* Unknown protected route -> dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>

        {/* Public fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;









































// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   Outlet,
// } from "react-router-dom";

// import Sidebar from "./components/Sidebar";
// import Dashboard from "./components/Dashboard";

// //Order components
// import Orders from "./components/pages/orders/Orders.jsx";
// import OrderSummary from "./components/pages/orders/OrderSummary.jsx";
// import PendingOrders from "./components/pages/orders/PendingOrders.jsx";
// import OrderDetails from "./components/pages/orders/OrderDetails.jsx";
// import ConfirmedOrders from "./components/pages/orders/ConfirmedOrders.jsx";
// import ShippedOrders from "./components/pages/orders/ShippedOrders.jsx";
// import DeliveredOrders from "./components/pages/orders/DeliveredOrders.jsx";
// import CanceledOrders from "./components/pages/orders/CancelledOrders.jsx";

// import CategoryManagement from "./components/pages/Category";
// import SubcategoryManagement from "./components/pages/subcategories";

// import AllUsers from "./components/pages/Users/allUsers";
// import CreateUser from "./components/pages/Users/createUser";
// import NewUsers from "./components/pages/Users/newUsers";
// import UserDetails from "./components/pages/Users/UserDetails.jsx";
// import InterestedBuyer from "./components/pages/Users/interestedBuyer.jsx";

// import CreateAdmin from "./components/admin/createAdmin";
// import ManageAdmins from "./components/admin/getAllAdmins";

// import InterestedUsers from "./components/pages/interestedUsers/interestedUsers";

// import Products from "./components/pages/manageProducts/products";
// import NewProduct from "./components/pages/manageProducts/NewProduct";
// import TotalProducts from "./components/pages/manageProducts/TotalProducts";
// import ApprovedProducts from "./components/pages/manageProducts/ApprovedProducts";
// import NotApprovedProducts from "./components/pages/manageProducts/NotApprovedProducts";
// import ApproveProductsPage from "./components/pages/manageProducts/NotApprovedProducts";
// import ProductDetails from "./components/pages/manageProducts/ProductDetails";
// import CreateProduct from "./components/pages/manageProducts/CreateProduct";
// import SellerProduct from "./components/pages/manageProducts/SellerProducts";
// import SaleBySellerPage from "./components/pages/manageProducts/SaleBySellerPage";
// import SaleByOGCSPage from "./components/pages/manageProducts/SaleByOGCSPage";
// import SellerDetailsPage from "./components/pages/manageProducts/SellerDetailsPage.jsx";
// import OgcsSellerDetailsPage from "./components/pages/manageProducts/OgcsSellerDetailsPage.jsx";

// import AllSellers from "./components/pages/Sellers/allSellers.jsx";

// import SellerProductsPage from "./components/account/sellerPayment.jsx";
// import SellerRegistrationPaymentsPage from "./components/account/SellerRegistrationPaymentPage.jsx";

// import AllUsersPage from "./components/data/user.jsx";
// import AdminDataPage from "./components/data/admin.jsx";
// import AddressDataPage from "./components/data/address.jsx";
// import CartDataPage from "./components/data/carts.jsx";
// import CategoryDataPage from "./components/data/categories.jsx";
// import DeliveryChargeDataPage from "./components/data/deliverycharges.jsx";
// import SubCategoriesDataPage from "./components/data/subcategories.jsx";
// import InterestedUsersDataPage from "./components/data/interestedusers.jsx";
// import OtherPaymentDataPage from "./components/data/Otherpayments.jsx";
// import OrdersPage from "./components/data/order.jsx";
// import OrderTrackingPage from "./components/data/ordertracking.jsx";
// import SellerProductVisibilityPage from "./components/data/sellerProductPayments.jsx";
// import SellersPage from "./components/data/seller.jsx";
// import WishlistPage from "./components/data/wishlist.jsx";

// import Settings from "./components/pages/Settings.jsx";
// import Locations from "./components/pages/Locations.jsx";
// import POS from "./components/pages/POS.jsx";

// import Login from "./components/admin/loginpage";
// import Register from "./components/admin/Register.jsx";

// import ProtectedRoute from "./components/protectedRoute/protectedRoute.jsx";

// // ✅ Layout for protected area
// const AdminLayout = () => (
//   <div className="flex min-h-screen">
//     <Sidebar />
//     <div className="flex-grow p-4 bg-gray-100">
//       <Outlet />
//     </div>
//   </div>
// );

// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         {/* Public */}
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />

//         {/* Protected (admin) */}
//         <Route element={<ProtectedRoute role="admin" />}>
//           <Route element={<AdminLayout />}>
//             <Route path="/" element={<Dashboard />} />

//             {/* Orders || this two same file i have orders/all | orders */}
//             <Route path="/orders" element={<OrderSummary />} />
//             <Route path="/orders/all" element={<Orders />} />
//             <Route path="/orders/pending" element={<PendingOrders />} />
//             <Route path="/orders/confirmed" element={<ConfirmedOrders />} />
//             <Route path="/orders/cancelled" element={<CanceledOrders />} />
//             <Route path="/orders/delivered" element={<DeliveredOrders />} />
//             <Route path="/orders/shipped" element={<ShippedOrders />} />
//             <Route path="/orders/:orderId" element={<OrderDetails />} />


//             {/* Category */}
//             <Route path="/category" element={<CategoryManagement />} />
//             <Route path="/subcategories" element={<SubcategoryManagement />} />

//             {/* Users */}
//             <Route path="/users/all" element={<AllUsers />} />
//             <Route path="/users/create" element={<CreateUser />} />
//             <Route path="/users/new" element={<NewUsers />} />
//             <Route path="/users/interested" element={<InterestedBuyer />} />
//             <Route path="/user/:id" element={<UserDetails />} />

//             {/* Admins */}
//             <Route path="/admins/create" element={<CreateAdmin />} />
//             <Route path="/admins/all" element={<ManageAdmins />} />

//             {/* Interested Users */}
//             <Route path="/salebysellers" element={<InterestedUsers />} />

//             {/* Products */}
//             <Route path="/products" element={<Products />} />
//             <Route path="/products/new" element={<NewProduct />} />
//             <Route path="/products/total" element={<TotalProducts />} />
//             <Route path="/products/approved" element={<ApprovedProducts />} />
//             <Route path="/products/not-approved" element={<NotApprovedProducts />} />
//             <Route path="/waiting-for-approval" element={<ApproveProductsPage />} />
//             <Route path="/products/details/:id" element={<ProductDetails />} />
//             <Route path="/products/create" element={<CreateProduct />} />

//             {/* Seller Products / Sales */}
//             <Route path="/seller-products" element={<SellerProduct />} />
//             <Route path="/sale-by-seller" element={<SaleBySellerPage />} />
//             <Route path="/seller-details/:sellerId" element={<SellerDetailsPage />} />
//             <Route path="/sale-by-ogcs" element={<SaleByOGCSPage />} />
//             <Route path="/ogcs-product-details/:id" element={<OgcsSellerDetailsPage />} />
//             <Route path="/product/:id" element={<ProductDetails />} />

//             {/* Sellers */}
//             <Route path="/sellers" element={<SellersPage />} />
//             <Route path="/sellers/all" element={<AllSellers />} />

//             {/* Accounts */}
//             <Route path="/accounts/seller" element={<SellerProductsPage />} />
//             <Route
//               path="/accounts/seller/registration"
//               element={<SellerRegistrationPaymentsPage />}
//             />

//             {/* Data Pages */}
//             <Route path="/all-users" element={<AllUsersPage />} />
//             <Route path="/admin" element={<AdminDataPage />} />
//             <Route path="/address" element={<AddressDataPage />} />
//             <Route path="/carts" element={<CartDataPage />} />
//             <Route path="/categories" element={<CategoryDataPage />} />
//             <Route path="/delivery-charges" element={<DeliveryChargeDataPage />} />
//             <Route path="/sub-categories" element={<SubCategoriesDataPage />} />
//             <Route path="/interested-users" element={<InterestedUsersDataPage />} />
//             <Route path="/other-payments" element={<OtherPaymentDataPage />} />
//             <Route path="/order" element={<OrdersPage />} />
//             <Route path="/order-tracking" element={<OrderTrackingPage />} />
//             <Route
//               path="/seller-product-payments"
//               element={<SellerProductVisibilityPage />}
//             />
//             <Route path="/wishlist" element={<WishlistPage />} />

//             {/* Settings / POS / Locations */}
//             <Route path="/settings" element={<Settings />} />
//             <Route path="/pos" element={<POS />} />
//             <Route path="/locations" element={<Locations />} />

//             {/* Unknown protected route -> dashboard */}
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Route>
//         </Route>

//         {/* Public fallback */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </Router>
//   );
// };

// export default App;